import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Stack
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import chatApi from '../../api/chatApi';
import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import { formatDate } from '../../utils/dateFormatter';

export default function ChatListPageMobile() {
  const { user } = useContext(AuthContext);
  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    try {
      const res = await chatApi.listRooms();
      setRooms(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container sx={{ mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Chat
      </Typography>

      <ProtectedAction user={user} roles={['ADMIN']}>
        <Button
          variant="contained"
          fullWidth
          sx={{ mb: 2 }}
          onClick={() => navigate('/chatroomcreate')}
        >
          Nuova stanza
        </Button>
      </ProtectedAction>

      {rooms.map(room => (
        <Accordion key={room.id}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>{room.name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Tipo: {room.type}
            </Typography>
            <Typography variant="body2">
              Creata il: {formatDate(room.createdAt)}
            </Typography>

            <Button
              sx={{ mt: 1 }}
              variant="outlined"
              onClick={() => navigate(`/chatroom/${room.id}`)}
            >
              Apri
            </Button>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}